import React from 'react';
import styles from './wishlistPage.module.css';
import { Header } from '../../components/Header/Header';
import wishlistIcon from '../../assets/wishlist-icon.svg';
import { SidesItem } from '../../components/SidesItem/SidesItem';
import { BlueBtn } from '../../UI/BlueBtn/BlueBtn';
import {
	useGetUserWishlistQuery,
	useDeleteWishlistItemMutation,
} from '../../store/api/wishlist.api';
import { useDbUserId } from '../../hooks/useDbUserId';

export const WishlistPage = () => {
	const schema = window.sessionStorage.getItem('schema');
	const { dbUserId } = useDbUserId();

	const { data, isLoading, refetch } = useGetUserWishlistQuery(
		{ userId: dbUserId, schema },
		{ skip: !dbUserId }
	);

	const [deleteWishlistItem] = useDeleteWishlistItemMutation();
	const wishlist = data?.items || [];

	const handleDelete = async (wishlistItem) => {
		try {
			const body = {
				userId: dbUserId,
				itemId: wishlistItem.itemId || null,
				subscriptionId: wishlistItem.subscriptionId || null,
			};

			await deleteWishlistItem({ data: body, schema }).unwrap();
			refetch();
		} catch (error) {
			console.error('Ошибка при удалении из избранного', error);
		}
	};

	if (isLoading) {
		return <div className={styles.loading}>Загрузка...</div>;
	}

	const calculateOriginalPrice = () => {
		return wishlist.reduce((sum, item) => {
			if (item.itemId) {
				return sum + (item.item?.price || item.item?.P2_price || 0);
			}
			if (item.subscriptionId) {
				return sum + (item.subscription?.price ?? 0);
			}
			return sum;
		}, 0);
	};

	const calculateDiscountedPrice = () => {
		return wishlist.reduce((sum, item) => {
			if (item.itemId) {
				return sum + (item.item?.price_disc || item.item?.price || item.item?.P2_price_disc || item.item?.P2_price || 0);
			}
			if (item.subscriptionId) {
				return sum + (
					item.subscription?.price_disc_sub ??
					item.subscription?.price_disc ??
					item.subscription?.price ??
					0
				);
			}
			return sum;
		}, 0);
	};

	const originalPrice = calculateOriginalPrice();
	const discountedPrice = calculateDiscountedPrice();
	const discountPercentage =
		originalPrice > 0
			? Math.round(((originalPrice - discountedPrice) / originalPrice) * 100)
			: 0;

	return (
		<div className={'main'}>
			<Header />
			<div className={styles.header}>
				<div className={styles.title_block}>
					<img src={wishlistIcon} alt="wishlistIcon" />
					<h2>Лайки</h2>
				</div>
				<p>{wishlist.length} товаров</p>
			</div>

			<div className={styles.items_block}>
				{wishlist.length > 0 ? (
					wishlist.map((item, index) => (
						<React.Fragment key={item.id || index}>
							<SidesItem
								item={item.itemId ? item.item : item.subscription}
								itemType={"P2"}
								onDelete={() => handleDelete(item)}
								from={'Wishlist'}
							/>
							{index !== wishlist.length - 1 && <div className={styles.line}></div>}
						</React.Fragment>
					))
				) : (
					<div className={styles.empty}>Ваш список избранного пуст</div>
				)}
			</div>

			{wishlist.length > 0 && (
				<div className={styles.footer}>
					<p className={styles.title}>Сумма товаров в лайках</p>
					{discountPercentage > 0 && (
							<span className={styles.price_amount}>{originalPrice.toFixed(2)} ₽</span>
					)}
					<h2 style={discountPercentage > 0 ? {color: 'red'} : {}}>{discountedPrice.toFixed(2)} ₽</h2>
					<div className={styles.footerLine}></div>
					<BlueBtn type={'toBasket'} text='Перейти в корзину'/>
				</div>
			)}
		</div>
	);
};
